import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, Validators, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { DashCred } from "src/app/models/dash";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
import { sortBy } from "underscore";
import moment from "moment";
import { NgbDatepickerConfig } from "@ng-bootstrap/ng-bootstrap";
import { ThemePalette } from '@angular/material/core';
import { OrgService } from "src/app/models/orgsrv";
import { TrimFormValuesService } from 'src/app/common/trimmingForm';
// Loading screen
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}

@Component({
  selector: 'app-physician-payload',
  templateUrl: './physician-payload.component.html',
  styleUrls: ['./physician-payload.component.css']
})
export class PhysicianPayloadComponent implements OnInit {

  form: FormGroup;
  selectedCheckBoxList = [];
  appointments: any = [];
  page: number = 1;
  pagesize: number = Utils.DEFAULT_PAGE_COUNT_SHOW;
  pageCount: number[] = Utils.PAGE_COUNT;
  collectionSize: number;
  findAppointmentForm: FormGroup;
  appointmentType = Utils.APPOINTMENT_TYPE;
  noAppointments: boolean = false;
  filterActive: boolean = false;
  dateFormat = Utils.DATE_FORMAT;
  activeBtn: string;
  maxDate: { year: number; month: number; day: number };
  aid: any;
  srvdet: OrgService[];
  service_list = [{ id: null, }];
  payloadInvoce: any;
  list: any[];
  // form: any = null;
  totalamount: number;
  service_lists: { id: any; }[];
  constructor(
    private service: VproService,
    private orgsrv: VproService,
    private spinner: NgxSpinnerService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private utils: Utils,
    private config: NgbDatepickerConfig,
    private formBuilder: FormBuilder,
    private trimFormValuesService: TrimFormValuesService,
  ) {

    this.form = this.formBuilder.group({
      id: this.formBuilder.array([], [Validators.required])
    })


    console.log(" this.form this.form1111", this.form)
    const current = new Date();
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
  }

  controlOnChange(e) {
    const ids: FormArray = this.form.get('id') as FormArray;

    if (e.target.checked) {
      ids.push(new FormControl(e.target.value));
      this.selectedCheckBoxList.push(e.target.value);
    } else {
      const index = ids.controls.findIndex(id => id.value === e.target.value);
      ids.removeAt(index);
    }
  }

  ngOnInit(): void {
    this.findAppointmentForm = this._formBuilder.group({
      patName: [""],
      fromDate: [null],
      toDate: [null],
      // service_id: [""],
    });

    this.getCheckinId();

  }


  getCheckinId() {
    this.orgsrv.getOrgService(localStorage.getItem("orgcode")).subscribe(data => {
      this.srvdet = data;
      console.log("-----------------------------------------------------------");
      this.list = [this.srvdet];
      // console.log(this.srvdet);
    });

  }

  allComplete: boolean = false;
  getAppointments(type: string = "", pg: number = 1) {
    let data = {};
    let val = this.findAppointmentForm.value;
    // console.log("val =", val)
    // console.log("console.log(this.form.value);",)
    // console.log(this.form.value);
    data["drid"] = JSON.parse(localStorage.getItem("uid"));
    if (val.patName) {
      data["pat_name"] = this.findAppointmentForm.value.patName;
    }
    else {
      data["pat_name"] = '';

    }

    if (val.fromDate) {
      console.log("val.fromDate", val.fromDate)
      let dd = val.fromDate.day;
      let mm = val.fromDate.month;

      let yyyy = val.fromDate.year;
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      let fidate = yyyy + '-' + mm + '-' + dd;
      console.log("fidate", fidate)
      let fdate = moment(val.fromDate).format("YYYY-MM-DD");
      console.log("fdate", fdate)
      data["from_date"] = fidate;
    }
    else {
      data["from_date"] = null;
    }
    if (val.toDate) {
      let dd = val.toDate.day;
      let mm = val.toDate.month;

      let yyyy = val.toDate.year;
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      let ladate = yyyy + '-' + mm + '-' + dd;
      let ldate = moment(val.toDate).format("YYYY-MM-DD");
      console.log("ldate", ldate)
      data["to_date"] = ladate;
    }
    else {
      data["to_date"] = null;
    }
    this.trimFormValuesService.trimValues(data);
    // console.log("this.form.value", this.form.value)
    // console.log("this.form.value.id", this.form.value.id)
    // console.log("this.form.value.Arr", this.form.value.id.array)
    // console.log("this.form.value.id.length", this.form.value.id.length)
    // console.log("this.form.value.length", this.form.value.length)
    // console.log("111111111111111111111111111111111111111111111111", this.service_list)
    if (this.form.value.id.length > 0) {
      // console.log("this.form.value.id", this.form.value.id)
      this.service_lists = [{ id: this.form.value.id, }];
      // console.log("this.service_lists", this.service_lists)
      data["service_list"] = this.service_lists;
    }
    else {
      // console.log("elseeeeeeeeee")
      // this.service_list = { service_id: number; };
      console.log("this.service_list", this.service_list)
      data["service_list"] = this.service_list;
    }
    // service_list
    this.spinner.show();
    this.service
      .fetchPayoutInvoice(data,)
      .subscribe(
        (res) => {
          this.spinner.hide();
          let total = 0;
          this.payloadInvoce = res;

          if (this.payloadInvoce.length === 0) {
            this.showToast('error', 'No records available for the search');
          }

          for (var i = 0; i < res.length; i++) {
            total += parseInt(this.payloadInvoce[i].scost);
            this.totalamount = total;
          }
        });
  }

  goToPrescription(apt) {
    // check if appointment status is not completed
    if (apt && apt.schedule_stat) {
      if ([Utils.APPOINTMENT_STATUS.NOT_COMPLETED].includes(apt.schedule_stat)) {
        // Sweet Alert
        Swal.fire({
          position: "top",
          type: "success",
          title: "Consultation summary not available",
          showConfirmButton: false,
          timer: 1700,
        });
      } else {
        if (apt.apttype == Utils.APPOINTMENT_TYPE.IN_PERSON) {
          this.router.navigate([`/phydash/${apt.pid}`], { queryParams: { cid: apt.cid } });
        } else {
          this.router.navigate(['/physician/consultation'], { queryParams: { pid: apt.pid, drid: apt.drid, aid: apt.aid, aptid: apt.aptid } });
        }
      }
    }
  }
  // Alert message
  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  pageChanged() {
    this.getAppointments(this.activeBtn, this.page);
  }

}
